// Search on the Fee Slips & Invoices tab.
//
// The list is clerk-first - nothing shows until a clerk is chosen - which is right for
// sending one clerk their outstanding fees, but no help for finding one particular fee
// slip when you don't know whose list it is in. A search therefore looks across every
// clerk (and the older items a clerk's statement normally hides), and a clerk chosen as
// well narrows it to that clerk.
//
// Every word typed must match somewhere on the fee slip, in any order: "towle meldrum"
// finds Thomas Towle's invoice from Meldrums. Numbers match without their leading zeros or
// formatting, so "600448" finds invoice 00600448 and "1,301.30" or "1301.3" finds that
// amount.

// Apostrophes are dropped on both sides, so "meldrums" finds "Meldrum's List" and
// "obrien" finds "O'Brien".
const lower = (value) => String(value ?? "").toLowerCase().replace(/['‘’`]/g, "");

// "00600448" -> "600448"; "1,301.30" -> "1301.30". Only digits, commas and one point.
function numberForms(value) {
  const text = String(value ?? "").trim();
  if (!/^[$\d,.\s]+$/.test(text) || !/\d/.test(text)) return [];
  const plain = text.replace(/[$,\s]/g, "");
  const forms = [plain, plain.replace(/^0+(?=\d)/, "")];
  const amount = Number(plain);
  if (Number.isFinite(amount) && plain.includes(".")) forms.push(String(amount), amount.toFixed(2));
  return forms;
}

// Everything on a fee slip a person might search by.
export function feeSlipSearchText(item = {}) {
  const amount = Number.parseFloat(item.invoiceAmount);
  const words = [
    item.clientName,
    item.counselName,
    item.clerkName,
    item.invoiceName,
    item.invoiceRef,
    item.notes,
    item.statementNotes,
    item.subject,
    item.matterId,
    item.rawEmail?.sender,
    Number.isFinite(amount) && amount > 0 ? `${amount.toFixed(2)} ${amount}` : "",
  ];
  const text = lower(words.filter(Boolean).join(" "));
  // Invoice numbers also without leading zeros, so either spelling of them is found.
  const unpadded = text.match(/\b0+\d{3,}\b/g)?.map((n) => n.replace(/^0+/, "")) || [];
  return `${text} ${unpadded.join(" ")}`;
}

export function searchTerms(query = "") {
  return lower(query).split(/\s+/).filter(Boolean);
}

export function matchesFeeSlipSearch(item, query) {
  const terms = searchTerms(query);
  if (!terms.length) return true;
  const text = feeSlipSearchText(item);
  const plain = text.replace(/,/g, "");
  return terms.every((term) => {
    if (text.includes(term)) return true;
    return numberForms(term).some((form) => form && plain.includes(form));
  });
}
